import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function Box({ children }) {
  return (
    <div
      style={{
        display: "block",
        lineHeight: 1,
        marginBottom: "8px",
        width: "160px",
      }}
    >
      {children}
    </div>
  );
}

const MainInfoSkeleton = () => {
  const containerStyle = {
    gap: "0",
    marginBottom: "0",
  };

  return (
    <div className="r_info" style={containerStyle}>
      <SkeletonTheme
        baseColor="#D8DBE0"
        highlightColor="#EDF1F6"
        borderRadius={"4px"}
      >
        <Skeleton wrapper={Box} height={31} />
        <Skeleton wrapper={Box} count={2} height={16} />
      </SkeletonTheme>
    </div>
  );
};

export default MainInfoSkeleton;
